import React, { useEffect, useState } from 'react';


const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);


  return (

    <label className="toggle-outer ev-message-card5 px-1 avatar-tooltip" data-tooltip="Color Theme">
      <button
        className={`toggle-button toggle-button-light ${theme === 'light' ? 'active' : ''} me-2`}
        onClick={() => setTheme('light')}
      >
        <i className ="bi bi-brightness-high"></i> 
      </button>
      <button
        className={`toggle-button toggle-button-dark ${theme === 'dark' ? 'active' : ''}`}
        onClick={() => setTheme('dark')}
      >
       <i className ="bi bi-moon"></i> 
      </button>
    </label>

  );
};

export default ThemeToggle;